import { Component, OnInit, Renderer2, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  ComparisonOperator,
  CustomResultOfByteOf,
  ExcelErrors,
  GetEnumValuesDto,
  GetExcelsWithPaginationDto,
  PaginatedListOfGetExcelsWithPaginationDto,
} from 'src/app/core/api/models';
import { ExcelService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppConfigService } from 'src/app/core/services/config.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ChangeExcelStatusFormComponent } from './change-excel-status-form/change-excel-status-form.component';

@Component({
  selector: 'app-excel-request',
  templateUrl: './excel-request.component.html',
  imports: [BaseIndexModule, MenuBtnComponent],
})
export class ExcelRequestComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  renderer = inject(Renderer2);

  pageName = PageNames.excelRequest;
  modelWithPagination$: Observable<PaginatedListOfGetExcelsWithPaginationDto>;
  items$: Observable<Array<GetExcelsWithPaginationDto>>;
  TypeEnumValues: GetEnumValuesDto[] = [];
  ExcelErrorsEnumValues: GetEnumValuesDto[] = [];
  apiUrl = AppConfigService.config.apiUrl;

  /* binding service CRUD endpoints */
  protected currentService = inject(ExcelService);
  paginationApiMethodName: string =
    this.currentService.excelGetExcelsWithPagination.name;
  auditApiMethodName: string = this.currentService.excelGetExcelAudits.name;
  /* binding service CRUD endpoints */

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit(false, false);
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showRefreshBtn = false;
      if (window.location.search == '') this.setDefaultStatusSearch();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.requests);
    }
  }

  setDefaultStatusSearch() {
    // try {
    //   let status = {
    //     field: 'errors',
    //     operator: 2,
    //     value: ExcelErrors.Archive.toString(),
    //   };
    //   this.comparisonObjects.push({
    //     comparisonObjects: [status],
    //     logicalComparisonOperator: LogicalComparisonOperator.Or,
    //   });
    // } catch (error) {
    //   this.loggerService.logError(this.tagName, error, EventTypes.requests);
    // }
  }

  getEnumsValues() {
    this.getEnumValuesApi('ExcelTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.TypeEnumValues = values));
    this.getEnumValuesApi('ExcelErrors')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.ExcelErrorsEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: '',
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
      },
      { title: this.localizer.id, name: 'id', hasSearch: true },
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: `${this.tableVocabs}type`,
        name: 'type',
        hasSearch: true,
        type: 'enum',
        enumName: 'ExcelTypes',
      },
      {
        title: `${this.tableVocabs}errors`,
        name: 'errors',
        hasSearch: true,
        type: 'enum',
        enumName: 'ExcelErrors',
        defaultSearchValue:
          window.location.search == '' ? ExcelErrors.Archive : '',
        defaultOperator:
          window.location.search == '' ? ComparisonOperator.NotEqualTo : '',
      },
      {
        title: `${this.tableVocabs}isReadyForDownload`,
        name: 'isReadyForDownload',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        type: 'dateTime',
        hasSearch: true,
      },
    ];
  }

  onClearQueryString() {
    this.getComparisonObjects(this.convertFilters(), true);
    this.getSortItems(this.convertSort(), true);
    this.changePageSize(30, true);
    super.ngOnInit(false, false);
    this.setDefaultStatusSearch();
  }

  downloadFileApi(requestId, title) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .excelDownload({ body: { id: requestId } })
      .pipe(this.basePipeOperators())
      .subscribe({
        next: (result: CustomResultOfByteOf) => {
          this.convertAndDownloadFile(result?.data, title);
        },
        error: (error) => {
          ConsoleService.error('error', error);
        },
        complete: () => (this.pageConfig.loading = false),
      });
  }

  //#endregion

  //#region download
  downloadFile(id, title) {
    this.downloadFileApi(id, title);
  }

  convertAndDownloadFile(result, title) {
    const byteCharacters = atob(result);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], {
      type: 'application / vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    const anchor = this.renderer.createElement('a');
    this.renderer.setProperty(anchor, 'download', title + `.xlsx`);
    this.renderer.setProperty(anchor, 'href', url);
    anchor.click();
  }
  //#endregion

  //change Status To
  onChangeStatus() {
    if (this.selectedIds?.length === 0) return;
    this.onChangeStatusModal(null);
  }

  onChangeStatusModal(id?: number) {
    try {
      this.unSubs();
      if (id) {
        this.selectedIds = [];
        this.selectedIds.push(id);
      }
      let data = {
        title: `${this.formPageConfig?.vocabs}changeStatusTitle`,
        isEdit: true,
        model: {
          ids: this.selectedIds,
        },
      };

      const modalResult = this.dialogService.openModal({
        component: ChangeExcelStatusFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
          }
          this.selectedIds = [];
          this.unCheckSelectAll();
          this.cd.detectChanges();
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.requests);
    }
  }
  //#endregion
}
